import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleRischi() {
  return <ArticleLayout article={articleContents['itaobuy-rischi']} />;
}